export default __webpack_public_path__ + "static/media/commissions1.b256db98.svg";